/* eslint-disable react/jsx-no-literals */
import { Box, Stack } from '@chakra-ui/react'
import Link from 'next/link'

import {
  Body,
  ContentStack,
  Cta,
  Detail,
  Divider,
  Logo,
  Privacy,
} from '@gaia-family/ds'
import { FormattedMessage } from 'react-intl'
import { useLocalisedConfig } from '@hooks/useLocalisedConfig'

const SiteFooter = () => {
  const { country } = useLocalisedConfig()
  return (
    <Stack
      alignItems={['flex-start', 'center']}
      justifyContent="space-between"
      direction={['column', 'row']}
      spacing="md"
    >
      <Logo width={66} />
      <Stack direction={['column', 'row']} spacing="md">
        <a href="/claims" target="_blank" rel="noopener noreferrer">
          <Detail>
            <FormattedMessage defaultMessage="Claims & Complaints" />
          </Detail>
        </a>
        <Privacy country={country}>
          <Detail>
            <FormattedMessage defaultMessage="Privacy notice" />
          </Detail>
        </Privacy>
      </Stack>
    </Stack>
  )
}

const PageFooter = () => (
  <Stack
    alignItems={['flex-start', 'center']}
    justifyContent="space-between"
    direction={['column', 'row']}
    spacing="md"
  >
    <Link href="/about/contact" passHref>
      <Cta as="a">
        <FormattedMessage defaultMessage="Contact us" />
      </Cta>
    </Link>
  </Stack>
)

const Disclaimer = ({ minimal }: { minimal?: boolean }) => (
  <Box maxWidth="container.xl">
    <ContentStack maxWidth="prose">
      <Body>
        <FormattedMessage
          defaultMessage="Copyright {year} Gaia Fertility Limited. All rights reserved."
          values={{ year: new Date().getFullYear() }}
        />
      </Body>
      <Body>
        <FormattedMessage defaultMessage="Gaia Fertility Limited is a private limited company registered in England and Wales under Company Number 12009812 at registered office address Great Western Studios, 65 Alfred Rd, London, W2 5EU." />
      </Body>
      {!minimal ? (
        <Body>
          <FormattedMessage defaultMessage="Gaia Fertility Ltd is authorised and regulated by the Financial Conduct Authority in the UK under Firm Reference Number 985551." />
        </Body>
      ) : null}
    </ContentStack>
  </Box>
)

export const Footer = ({ minimal }: { minimal?: boolean }) => (
  <Stack width="100%" py="xl" layerStyle="softBlack" alignItems="center">
    <Stack
      width="100%"
      spacing="xl"
      maxWidth="container.xl"
      alignItems="stretch"
    >
      <PageFooter />
      <Divider />
      <SiteFooter />
      <Disclaimer minimal={minimal} />
    </Stack>
  </Stack>
)
